import React from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
export const TriggersTableLayout = observer(() => {
  return <Outlet />
})
